Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TikTokAdContentFactory

  create: (socialContent, allTags) ->
    return new Monitoring.Models.SocialContents.TikTokAdContent(socialContent).set({ possibleTags: allTags })

  canHandle: (socialContent) ->
    return socialContent.sub_type == 'tiktok-ad'
